<template>
  <div>
    <el-badge :value="notification" class="mark" :is-dot="alert" :hidden="shouldHide">
      <i :class="icon" v-if="showIcon"></i> 
      <span class="label" v-html="label"></span>
    </el-badge>
  </div>
</template>

<script>
  export default {
    name: 'HeaderMenuItem',
    props: {
      showTooltip: {
        type: Boolean,
        default: true,
      },
      showIcon: {
        type: Boolean,
        default: false,
      },
      showLabel: {
        type: Boolean,
        default: true,
      },
      icon: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      notification: {
        type: Number,
        default: 0,
        required: false,
      },
      alert: {
        type: Boolean,
        default: false,
        required: false,
      },
      shouldHide: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
.label{
  text-indent: 10px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderMenuItem.vue